import { forwardRef, type InputHTMLAttributes } from "react";

type PennInputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

export const PennInput = forwardRef<HTMLInputElement, PennInputProps>(
  ({ error = false, className = "", ...props }, ref) => (
    <input
      ref={ref}
      {...props}
      className={[
        "w-full px-4 py-3 rounded-xl border text-sm text-penn-text placeholder-gray-400 outline-none transition disabled:opacity-50 disabled:cursor-not-allowed",
        error
          ? "border-error bg-error/5"
          : "border-gray-200 bg-gray-50 hover:border-penn-500",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    />
  )
);

PennInput.displayName = "PennInput";
